<template>
  <section>
    <div class="sonAccount">
      <div class="title">个人资料</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="原始密码" prop="userpwd">
          <el-input v-model="ruleForm.userpwd" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="userpwd1">
          <el-input v-model="ruleForm.userpwd1" type="password"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return {
      ruleForm: {
        userpwd: "",
        userpwd1: ""
      },
    

      rules: {
        userpwd: [
          { required: true, message: "原始密码", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        userpwd1: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let { userpwd1, userpwd } = this.ruleForm;
          let res = await this.$fetch("member/setpwd", {
            body: { userpwd1, userpwd }
          });
          if (res) {
            this.$message({
              message: "提交成功",
              type: "success"
            });
            this.$refs[formName].resetFields();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {}
};
</script>
<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/update_pwd.vue